<template>
	<div class="isdf7df" :class="[size, status]">
		<div
			v-for="(option, i) in options"
			:key="i"
			class="item"
			:class="{ selected: compare(option) }"
			tabindex="0"
			@keypress.enter="onClick(option)"
			@click="onClick(option)"
			@blur="$emit('blur')"
			@focus="$emit('focus')"
		>
			{{ option[nameKey] }}
		</div>
	</div>
</template>

<script>
export default {
	name: "j-base-checkbox-group",
	props: {
		value: {
			required: true,
			default: () => [{ name: null, value: null }],
			validator(val) {
				return val === null || val instanceof Array
			}
		},
		options: {
			type: Array,
			required: true,
			default: () => []
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		nameKey: {
			type: String,
			default: "name"
		},
		valueKey: {
			type: String,
			default: "value"
		}
	},

	methods: {
		compare(option) {
			if (!this.value) return false
			if (this.value.find(item => item === option[this.valueKey])) return true
			else return false
		},

		onClick(option) {
			let newValue = !this.value ? [] : [...this.value]

			// If item is in array, remove it
			if (newValue.find(item => item === option[this.valueKey]))
				newValue.splice(newValue.indexOf(option[this.valueKey]), 1)
			else newValue.push(option[this.valueKey]) // If item is not in array, add it

			// Return results
			this.$emit("input", newValue)
		}
	}
}
</script>

<style src="./index.css" scoped />
